import React, { Fragment } from 'react';
import { Card, Row, Col, Button, message, Modal } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getUrlSearchParams } from 'utils/utils.js';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import Result from 'components/ant-design-pro/Result';
import styles from './Scan.less';

@connect(({ operationChargeItemPublishSuccessScan, loading }) => ({
  successInfo: operationChargeItemPublishSuccessScan.successInfo,
  loading: loading.effects['operationChargeItemPublishSuccessScan/fetchSuccessInfo'],
}))
export default class SuccessScan extends React.Component {
  constructor(props) {
    super(props);

    this.searchParams = getUrlSearchParams();

    this.handleBackToList = this.handleBackToList.bind(this);
    this.handleCopied = this.handleCopied.bind(this);
    this.renderExtra = this.renderExtra.bind(this);
    this.renderActions = this.renderActions.bind(this);
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'operationChargeItemPublishSuccessScan/fetchSuccessInfo',
      id: this.searchParams.id,
    });
  }

  handleCopied(text, result) {
    if (!result || !text) {
      return Modal.warning({
        title: '提示',
        content: `复制失败，请手动复制链接 ${this.props.successInfo.url}`,
      });
    }
    message.success('链接已成功复制到剪贴板');
  }

  handleBackToList() {
    this.props.dispatch(routerRedux.replace('/operation/charge-item/list'));
  }

  renderExtra() {
    const { successInfo } = this.props;

    if (successInfo === null) {
      return null;
    }

    return (
      <Fragment>
        <Row className="url-wrap">
          <Col md={5} xs={24} className={styles['wrap-container']}>
            *支付链接：
          </Col>
          <Col md={13} xs={24} className={styles['wrap-container']}>
            <p className={styles['card-url']}>{successInfo.url}</p>
          </Col>
          <Col md={4} xs={24} offset={1}>
            <CopyToClipboard text={successInfo.url} onCopy={this.handleCopied}>
              <Button type="primary">点击复制</Button>
            </CopyToClipboard>
          </Col>
        </Row>
        <Row className="image-wrap">
          <Col md={5} xs={24} className={styles['wrap-container']}>
            二维码：
          </Col>
          <Col md={13} xs={24} className={styles['wrap-container']}>
            <img className="image" src={successInfo.qrCode} alt="支付二维码" />
          </Col>
        </Row>
      </Fragment>
    );
  }

  renderActions() {
    return (
      <div>
        <Button onClick={this.handleBackToList}>返回列表</Button>
      </div>
    );
  }

  render() {
    const { loading } = this.props;

    return (
      <Card bordered={false} className={styles.root}>
        <Result
          type="success"
          title={<div>{this.searchParams.title}创建成功 </div>}
          description="请将支付链接或者二维码发送给家长"
          extra={
            <Card bordered={false} loading={loading} className="extra-card">
              {this.renderExtra()}
            </Card>
          }
          actions={this.renderActions()}
        />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishSuccess/Scan.js